import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "../components/button";
import img from "../assets/icon/coolicon.png";
import {
  ComponentTabLink,
  ITabLink,
  ITabTitle,
  PageType,
} from "../components/component-tab";
import remove from "../assets/icon/exit.png";
import { FormError2 } from "../components/form-error";
import { AsideAdminComponent } from "../layout/aside-admin";
import {
  // 1. (변경) Edit에 필요한 타입과 훅 import
  EditMainCategoryInput,
  EditMainCategoryMutation,
  GetMainCategoryQuery,
} from "../generated/graphql";
import { upload } from "../functions/uploads";
import { IEditMainCategoryFormProps, useEditMainCategory } from "../hooks/useEditMainCategory";
import { useGetMainCategory } from "../hooks/useGetMainCategory";
import { useParams } from "react-router-dom"; // useParams 추가

// 폼 타입은 생성과 동일할 수 있으므로 재사용하거나 새로 정의합니다.
import { ICrMainCategoryFormProps } from "../hooks/useCrMainCategory";

// 컴포넌트 이름을 AdminEditCategory로 변경
export const AdminEditCategory = () => {
  // 2. (추가) URL에서 categoryId를 가져옵니다.
  const params = useParams<{ categoryId: string }>();

  const [out, setOut] = useState<boolean>(true);
  const [uploadUuid, setUploadUuid] = useState<string>("");
  const [imagePreviewUrl, setImagePreviewUrl] = useState<string>("");
  const [uploading, setUploading] = useState<boolean>(false);

  useEffect(() => {
    if (!out) {
      window.location.href = `/category`; // 수정 완료 후 이동할 경로
    }
  }, [out]);

  const {
    getValues,
    register,
    handleSubmit,
    setValue, // 3. (추가) 폼 값을 채우기 위해 setValue 사용
    formState: { errors, isValid },
  } = useForm<IEditMainCategoryFormProps>({ mode: "all" });

  // 4. (추가) 데이터 조회 완료 시 폼을 채우는 콜백 함수
  const onGetComplete = (data: GetMainCategoryQuery) => {
    const {
      getMainCategory: { ok, err, mainCategory },
    } = data;
    if (ok && mainCategory) {
      setValue("name", mainCategory.name);
      if (mainCategory.upload) {
        setImagePreviewUrl(mainCategory.upload.url || "");
        setUploadUuid(mainCategory.upload.uuid || "");
        console.log(mainCategory.upload.url);
        console.log(mainCategory.upload.uuid);
      }
    }
  };

  // 5. (추가) ID로 카테고리 정보를 가져오는 훅
  const [getMainCategory, { loading: getLoading }] = useGetMainCategory(
    onGetComplete
  );

  // 6. (변경) 생성(Cr) -> 수정(Edit) 완료 시 콜백
  const onEditComplete = (data: EditMainCategoryMutation) => {
    const {
      editMainCategory: { ok, err },
    } = data;
    if (ok) {
      alert("수정되었습니다.");
      setOut(false);
    } else {
      alert(err);
    }
  };

  // 7. (변경) 생성 -> 수정 뮤테이션 훅 사용
  const [editMainCategory, { loading: editLoading }] = useEditMainCategory(
    onEditComplete
  );

  const onSubmit = () => {
    const categoryId = Number(params.categoryId);
    if (!categoryId || editLoading) return;

    const { name } = getValues();
    // 8. (변경) 수정(Edit)에 필요한 input 생성
    const editMainCategoryInput: EditMainCategoryInput = {
      id: categoryId,
      name,
      imageUuid: uploadUuid,
    };
    editMainCategory({ variables: { input: editMainCategoryInput } });
  };

  const uploadPosterHandler = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (uploading) {
      alert("파일을 업로드 중입니다.");
      return;
    }

    const previewUrl = URL.createObjectURL(file);
    setImagePreviewUrl(previewUrl);

    const result = await upload(event);

    if (result.data.ok) {
      setUploadUuid(result.data.upload.uuid);
    } else {
      alert(`잘못된 파일`);
      setImagePreviewUrl("");
      URL.revokeObjectURL(previewUrl);
    }
  };

  // 9. (추가) 페이지 로드 시 카테고리 데이터 조회
  useEffect(() => {
    const categoryId = Number(params.categoryId);
    if (categoryId) {
      getMainCategory({ variables: { input: { id: categoryId } } });
    }
  }, [params.categoryId]);

  const tabList: ITabLink[] = [];
  // 10. (변경) 페이지 제목 수정
  const stitle: ITabTitle = { text: "카테고리 수정" };

  if (getLoading) {
    return <div>데이터를 불러오는 중입니다...</div>;
  }

  return (
    // ... JSX 구조는 생성 페이지와 대부분 동일 ...
    <div className="bg-main bg-opacity-50 w-full h-full min-h-screen">
      <div className="w-full mx-auto h-full min-h-screen bg-gray-100">
        <main id="main">
          <div className="grid grid-cols-[200px_1fr] max-w-full">
            <AsideAdminComponent />
            <div className="mypages bg-gray-100 w-full min-w-[1200px] overflow-hidden">
              <div className="orderWrap">
                <div className="h-fix-content relative">
                  <div className={`w-full h-full px-10 py-8`}>
                    <ComponentTabLink
                      tabs={tabList}
                      stitle={stitle}
                      type={PageType.Create} // 타입을 Update로 변경
                    />
                    <div className="shadow-lg w-full h-fix-content bg-white">
                      <form onSubmit={handleSubmit(onSubmit)} id="update">
                        <div className="pl-9 pr-11 py-8 space-y-4">
                          {/* 폼 내용은 생성 페이지와 동일 */}
                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              이름
                            </p>
                            <input
                              {...register("name", {
                                required: `이름을 입력해주세요`,
                              })}
                              type="text"
                              className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                            />
                            {errors.name?.message && (
                              <FormError2 errorMessage={errors.name.message} />
                            )}
                          </div>
                          <div className="flex flex-wrap gap-4">
                            <div
                              key={`thumbnail-${uploadUuid}`}
                              className="w-24 aspect-square border rounded-lg border-[#000000] relative"
                            >
                              <button
                                type="button" // form 제출 방지
                                className={`absolute -top-2 -right-2 bg-black rounded-full z-10`}
                                onClick={() => {
                                  setUploadUuid("");
                                  setImagePreviewUrl("");
                                }}
                              >
                                <img src={remove} alt={`이 이미지 없애기`} />
                              </button>
                              <label
                                htmlFor={`poster`}
                                className="flex flex-wrap w-full h-full content-center justify-center cursor-pointer"
                              >
                                {!imagePreviewUrl && <img src={img} alt="이미지 업로드 아이콘" />}
                                <img
                                  src={imagePreviewUrl}
                                  alt="썸네일"
                                  className={`absolute left-0 top-0 w-full h-full rounded-lg object-cover ${
                                    !imagePreviewUrl ? "hidden" : ""
                                  } `}
                                />
                              </label>
                              <input
                                type="file"
                                className="hidden"
                                id={`poster`}
                                accept="image/png, image/jpeg, image/jpg, image/gif"
                                onChange={uploadPosterHandler}
                              ></input>
                            </div>
                          </div>
                          <div className="flex flex-wrap justify-center pt-6">
                            <Button
                              className={`w-[240px] h-[40px] bg-[#3D3E49] text-white rounded-lg`}
                              canClick={true}
                              actionText={`수정`} // 버튼 텍스트 수정
                              loading={editLoading} // 로딩 상태 변경
                              color={"text-white"}
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};